import { Button, Form, Input, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import BtnEditSvg from "../Button/btnEditSvg";
import { EmployeeContactInformationUpdate, loadSingleStaff } from "../../../redux/rtk/features/user/userSlice";
import { getAllMaster } from "../../../redux/rtk/features/masters/masterSlice";

const { Option } = Select;

const ContactEditPopup = ({ userId, user }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { id } = useParams();
  const masterData = useSelector((state) => state?.masters?.masters)||[];


  // Fetch master data on component mount
  useEffect(() => {
    dispatch(getAllMaster());
  }, [dispatch]);

  // Prefill form with existing user data when modal opens
  useEffect(() => {
    if (isModalOpen && user) {
      form.setFieldsValue({
        EmployeeId: id,
        ContactPersonRelationId: user?.ContactPersonRelationId || undefined,
        ContactPersonName: user?.ContactPersonName || "",
        ContactPersonNumber: user?.ContactPersonNumber || "",
        ContactPersonAlternateNumber: user?.ContactPersonAlternateNumber || "",
        ContactPersonEmailId: user?.ContactPersonEmailId || "",
        DataStatus: 1,
      });
    }
  }, [isModalOpen, user, form, id]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const onFinish = async (values) => {
    try {
      const response = await dispatch(EmployeeContactInformationUpdate(values));
      if (response.payload.message === "success") {
         dispatch(loadSingleStaff(id));
        setIsModalOpen(false);
        form.resetFields();
      }
    } catch (error) {
      // console.error("Error updating contact details:", error);
    }
  };

  return (
    <>
      <button onClick={showModal}>
        <BtnEditSvg size={30} />
      </button>
      <Modal
        title="Update Contact Details"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          form={form}
          name="contactDetails"
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item name="EmployeeId" hidden>
            <Input />
          </Form.Item>

          <Form.Item name="DataStatus" hidden>
            <Input />
          </Form.Item>
          
          <Form.Item
            label="Emergency Contact Number"
            name="ContactPersonNumber"
            rules={[
              {
                pattern: /^[0-9]{10}$/,
                message: "Please enter a valid 10-digit phone number!",
              },
            ]}
          >
            <Input placeholder="Enter emergency contact number" />
          </Form.Item>

          <Form.Item
            label="Contact Person Name"
            name="ContactPersonName"
            rules={[
              {
                required: true,
                message: "Please enter the contact person name!",
              },
            ]}
          >
            <Input placeholder="Enter contact person name" />
          </Form.Item>
          <Form.Item
            label="Contact Person Alternate Number"
            name="ContactPersonAlternateNumber"
            rules={[
              {
                pattern: /^[0-9]{10}$/,
                message: "Please enter a valid 10-digit phone number!",
              },
            ]}
          >
            <Input placeholder="Enter alternate number" />
          </Form.Item>

          <Form.Item
            label="Contact Person Email"
            name="ContactPersonEmailId"
            rules={[
              {
                type: "email",
                message: "Please enter a valid email address!",
              },
            ]}
          >
            <Input placeholder="Enter contact person email" />
          </Form.Item>

          <Form.Item
            label="Contact Person Relation"
            name="ContactPersonRelationId"
            rules={[
              {
                required: true,
                message: "Please select a relation!",
              },
            ]}
          >
            <Select
              placeholder="Select relation"
              allowClear
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {masterData?.RelationTypeMaster?.map((relation) => (
                <Option
                  key={relation.RelationTypeId}
                  value={relation.RelationTypeId}
                >
                  {relation.RelationTypeName}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default ContactEditPopup;